<div class="tw-max-w-[95%] md:tw-max-w-[50%] tw-w-full tw-mb-[20px]">
    <div
        class="tw-h-[56px] tw-flex tw-flex-1 tw-content-center tw-gap-3 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-p-[18px] tw-bg-white"
    >
        <mat-icon fontIcon="search" class="tw-text-black"></mat-icon>
        <input
            class="tw-flex-1 tw-font-semibold"
            placeholder="{{ 'FAQ.SEARCH' | translate }}"
            [(ngModel)]="searchTerm"
            (keyup)="searchFaq()"
        />
    </div>
</div>

<div class="faq-container">
    <div class="faq-left">
        <ng-container
            *ngIf="category?.subcategories?.length; else noSubcategories"
        >
            <p class="tw-text-[#7B7575] tw-font-semibold tw-mb-4">
                {{ "FAQ.RELATED" | translate }}
            </p>
            <hr class="tw-border-[#7B7575] tw-mb-[20px]" />
            <div
                class="subcategory-accordion tw-flex tw-gap-[10px] tw-flex-col"
            >
                <div *ngFor="let sub of category?.subcategories; let i = index">
                    <button
                        class="tw-w-full tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-p-[10px] tw-font-bold"
                        (click)="toggleSubcategory(sub, i)"
                        [ngClass]="
                            openSubcategoryIndex === i &&
                            'tw-bg-[#e6e6e6] tw-rounded-[16px]'
                        "
                    >
                        {{
                                sub.categoryEn
                        }}
                        <mat-icon
                            class="tw-text-[#000000]"
                            [ngClass]="
                                openSubcategoryIndex === i
                                    ? 'tw-text-[#000000]'
                                    : ' tw-text-[#7B7575]'
                            "
                        >
                            {{
                                openSubcategoryIndex === i
                                    ? "expand_less"
                                    : "expand_more"
                            }}
                        </mat-icon>
                    </button>
                    <div *ngIf="openSubcategory === sub">
                        <ul class="tw-list-disc tw-pl-[25px] tw-m-[12px]">
                            <li *ngFor="let faq of sub.faq; let j = index">
                                <button
                                    class="faq-question"
                                    [ngClass]="
                                        selectedQuestionIndex === j
                                            ? 'tw-text-blue-500 !tw-font-semibold'
                                            : 'tw-text-black'
                                    "
                                    (click)="toggleQuestion(faq, j)"
                                >
                                    {{
                                        selectedLanguage == "en"
                                            ? faq.questionEn
                                            : faq.questionBm
                                    }}
                                </button>
                                <div
                                    *ngIf="
                                        !isDesktop && selectedQuestion === faq
                                    "
                                    class="faq-answer"
                                    [innerHTML]="
                                        selectedLanguage == 'en'
                                            ? faq.answerEn
                                            : faq.answerBm
                                    "
                                ></div>
                            </li>
                        </ul>
                        <hr
                            class="tw-w-[90%] tw-mx-auto tw-border tw-border-gray-400"
                        />
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-template #noSubcategories>
            <p class="tw-text-[#7B7575] tw-font-semibold tw-mb-4">
                {{ "FAQ.RELATED" | translate }}
            </p>
            <hr class="tw-border-[#7B7575] tw-mb-[20px]" />
            <div *ngFor="let faq of category?.faq; let k = index">
                <button
                    class="faq-question tw-w-full tw-flex tw-justify-between tw-items-center"
                    (click)="toggleQuestion(faq, k)"
                    [ngClass]="selectedQuestionIndex === k && 'tw-font-bold'"
                >
                    {{
                        selectedLanguage == "en"
                            ? faq.questionEn
                            : faq.questionBm
                    }}

                    <mat-icon
                        [ngClass]="
                            selectedQuestionIndex === k
                                ? 'tw-text-[#00000] tw-font-extrabold tw-text-[22px]'
                                : 'tw-text-[#7B7575] '
                        "
                        class="tw-text-[20px] tw-min-w-[24px]"
                        >chevron_right</mat-icon
                    >
                </button>
                <div
                    *ngIf="!isDesktop && selectedQuestion === faq"
                    class="faq-answer"
                    [innerHTML]="
                        selectedLanguage == 'en' ? faq?.answerEn : faq?.answerBm
                    "
                ></div>
            </div>
        </ng-template>
    </div>

    <div class="faq-right tw-mt-[55px]" *ngIf="isDesktop">
        <div *ngIf="selectedQuestion" class="tw-sticky tw-top-[90px]">
            <h3 class="!tw-mb-[10px] !tw-font-bold md:!tw-text-[25px]">
                {{
                    selectedLanguage == "en"
                        ? selectedQuestion?.questionEn
                        : selectedQuestion?.questionBm
                }}
            </h3>
            <hr />
            <div
                [innerHTML]="
                    selectedLanguage == 'en'
                        ? selectedQuestion?.answerEn
                        : selectedQuestion?.answerBm
                "
            ></div>
        </div>
    </div>
</div>
